import { useEffect, useRef, useState } from 'react';
import '../styles/TheSteps.css';

const CARDS = [
  {
    id: '01',
    title: 'Institutional Strategies',
    description: 'CeDeFi and On-chain Strategies combined to deliver institutional-grade yields.',
    icon: (
      <svg viewBox="0 0 40 40" fill="none">
        <path d="M20 6l14 8H6l14-8z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
        <path d="M10 17v11M17 17v11M23 17v11M30 17v11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M6 31h28" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: '02',
    title: 'Native Yields',
    description: 'Rewards paid in the asset you deposit, compounding automatically.',
    icon: (
      <svg viewBox="0 0 40 40" fill="none">
        <path d="M8 30V20M16 30V14M24 30V17M32 30V9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: '03',
    title: 'Multiple assets',
    description: 'Currently available for XRP, RLUSD. More tokens coming soon.',
    icon: (
      <svg viewBox="0 0 40 40" fill="none">
        <circle cx="14" cy="26" r="4.5" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="24" cy="26" r="3" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="19" cy="15" r="2.4" stroke="currentColor" strokeWidth="1.6" />
      </svg>
    ),
  },
];

export default function TheSteps({ zIndex }) {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="vaults-feature" style={{ zIndex }} ref={sectionRef}>
      <div className="vaults-feature__bg" aria-hidden="true" />

      <div className="vaults-feature__topbar">
        <span className="vaults-feature__brand">Doppler.finance</span>
        <span className="vaults-feature__pill">
          <span className="vaults-feature__pill-brace">{'{'}</span>
          Doppler Vaults
          <span className="vaults-feature__pill-brace">{'}'}</span>
        </span>
      </div>

      <h2 className="vaults-feature__heading">
        <span className="vaults-feature__line vaults-feature__line--muted">Earn Yields through</span>
        <span className="vaults-feature__line vaults-feature__line--bold">Doppler Vaults</span>
      </h2>

      <div className="vaults-feature__grid">
        {CARDS.map((card, i) => (
          <div
            key={card.id}
            className={`vaults-feature__card ${isVisible ? 'vaults-feature__card--visible' : ''}`}
            style={{ transitionDelay: `${i * 0.12}s` }}
          >
            <div className="vaults-feature__card-top">
              <span className="vaults-feature__card-icon">{card.icon}</span>
              <span className="vaults-feature__card-tag">Doppler Vaults #{card.id}</span>
            </div>
            <h3 className="vaults-feature__card-title">{card.title}</h3>
            <p className="vaults-feature__card-desc">{card.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}